module.exports = __webpack_public_path__ + "fonts/BwModelica-Black.e2a8d75b.ttf";